export default __webpack_public_path__ + "static/media/medicenter-slider-image-4.c704f673.jpg";